export const DEFAULT_ROUTE = "/"
export const FTTX_ROUTE = "broadband"
export const MIFI_ROUTE = "mifi"
export const BROADBAND_ROUTE = "/new-connection"
export const PAYMENT_NEW_ROUTE = "/payment-v2"
export const PREPAID_ROUTE = "/v2/prepaid-recharge"
export const POSTPAID_ROUTE = "/v2/postpaid-bill-pay"
export const BUY_BUNDLE_ROUTE = "/v2/buy-bundle";
export const PAYMENT_STATUS_ROUTE = "/payment/status"
export const PLANS_ROUTE = "/plans/:id"
export const DATA_CALCULATOR = "/data-calculator";
export const BROADBAND_RECHARGE_ROUTE = "/v2/broadband-recharge";
export const STORE_LOCATOR = "/storeLocator";
export const STAR_OIL = "/staroil";
export const AMB = "/AMB";
export const CHECK_ORDER_STATUS_ROUTE = "/check-order-status"
export const BROADBAND_RECHARGE_ROUTE_V3 = "/v2/broadband-recharge/broadband-plans";
export const BROADBAND_LINKED_DEVICES_ROUTE = "/v2/broadband-recharge/linked-devices";